import { useMemo } from 'react';

import { useWindowDimensions } from '@hooks/common/useWindowDimensions';

import { BreakpointSize } from '@constants/common/ui.constants';

export const useMediaQuery = () => {
  const { width } = useWindowDimensions();

  const isDesktop = useMemo(() => width >= BreakpointSize.Lg, [width]);
  const isLaptop = useMemo(
    () => width < BreakpointSize.Lg && width >= BreakpointSize.Md,
    [width],
  );
  const isTablet = useMemo(
    () => width < BreakpointSize.Md && width >= BreakpointSize.Sm,
    [width],
  );
  const isMobile = useMemo(() => width < BreakpointSize.Sm, [width]);

  const mobileView = useMemo(() => isTablet || isMobile, [isTablet, isMobile]);
  const laptopView = useMemo(
    () => isLaptop || isTablet || isMobile,
    [isLaptop, isTablet, isMobile],
  );
  const desktopView = useMemo(
    () => isDesktop || isLaptop,
    [isDesktop, isLaptop],
  );

  return {
    isDesktop,
    isLaptop,
    isTablet,
    isMobile,
    mobileView,
    laptopView,
    desktopView,
  };
};
